<template>
  <div class="seviceErr">
    <im-top></im-top>
    <img v-if="errType==='costomerErr'" class="errImg" :src="imgUrl+'im_sorry.png'" alt="无客服">
    <img v-if="errType==='serviceErr'" class="errImg" :src="imgUrl+'im_err.png'" alt="服务器忙">
    <div class="text" v-if="errType==='costomerErr'" v-html="msgService"></div>
    <div class="text" v-else>{{msgErr}}</div>
  </div>
</template>
<script>
import imTop from './IMTop.vue'
export default {
  components:{
    imTop
  },
  data () {
    return {
      imgUrl: '/pc/static/assets/',
      msgErr: '服务器繁忙，请稍后再试',
      msgService:'暂无服务的客服，请稍候再试！<br/>人工客服工作时间为每日 8:00-22:00，欢迎在此时段内联系我们～',
      errType:""
    }
  },
  mounted () {
    this.errType = this.$route.query.errType;
    this.randerPage();
  },
  methods: {
    randerPage () {
      clearInterval(this.$store.state.im.timer);
      var entranceId = sessionStorage.entranceId ? sessionStorage.entranceId : "";
      var vm = this;
      let visitorMd5Code = sessionStorage.md5; //
      // this.$store.dispatch({
      //           type: 'enterQueue',
      //           entranceId: entranceId,
      //           router: vm.$router,
      //           visitorMd5Code: visitorMd5Code
      //         })
    },
  }
}
</script>

<style scoped>
.seviceErr{
    /*height: 300px;
    width: 200px;
    background: #595959;*/
}
.errImg {
  display: block;
  width: 134px;
  margin:130px auto 25px auto;
  /*margin:-310px 0 0 -320px;*/
}
.text {
  text-align: center;
  color: #acb2b6;
}
</style>




// WEBPACK FOOTER //
// src/components/im/serviceError.vue?458d1114